import React, { FC, useState } from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Dismissal from "./tabs/Dismissal";
import { Wrapper } from "../styled";

const layoffTabs = [
{
    title: "Увольнение",
    component: <Dismissal/>,
}
];

const Layoff: FC = () => {
const [tab, setTab] = useState(0);

const handleChangeTab = (event: React.SyntheticEvent, newValue: number) => {
    setTab(newValue);
};

return (
    <Wrapper>
    <Tabs
        value={tab}
        onChange={handleChangeTab}
        variant="scrollable"
        scrollButtons="auto"
        aria-label="scrollable auto tabs example"
    >
        {layoffTabs.map((tab) => (
        <Tab key={tab.title} label={tab.title} />
        ))}
    </Tabs>
    {layoffTabs[tab].component}
    </Wrapper>
);
};

export default Layoff;
